import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Modal } from '@ers/ui/';
import { useSelectorWithDispatch } from '@ers/hooks';
import { fetchSystemNotification, updateSystemNotification } from '@ers/popups/Popup.actions';
import { getSystemNotification } from '@ers/popups/Popup.selectors';

import { Content, TITLE } from './StatuteContent';


// ----------- HOW TO USE IT? ------------
// Go to UserPopupNotificationContent.js
// Set new TITLE
// Create new Content
// Ask BE to add new position in systemNotifications
// et voilà

const SystemNotificationPopup = () => {
    const dispatch = useDispatch();
    const displaySystemNotificationPopup = useSelectorWithDispatch(
        getSystemNotification,
        fetchSystemNotification,
        (r) => !r
    );
    const handleClick = useCallback(() => {
        dispatch(updateSystemNotification());
    }, [displaySystemNotificationPopup]);

    return (
        <>
            {displaySystemNotificationPopup && (
                <Modal close={handleClick} title={TITLE}>
                    <Content />
                </Modal>
            )}
        </>
    );
};

export default SystemNotificationPopup;

